module.exports = __webpack_public_path__ + "sgby/img/short-normal.dae0b45.png";